import { css } from '@/styles/emotion'
import type { UnovisCssVariablesDefinition } from '@/types/style'
import { getCssVarNames, injectGlobalCssVariables } from '@/utils/style'

export const root = css`
  label: timeline-component;
`

export const cssVarDefaults: UnovisCssVariablesDefinition = {
  '--vis-timeline-row-even-fill-color': '#FFFFFF',
  '--vis-timeline-row-odd-fill-color': '#F7FAFC',
  '--vis-timeline-row-background-opacity': '1',
  '--vis-timeline-scrollbar-background-color': '#E6E9F3',
  '--vis-timeline-scrollbar-color': '#9EA7B8',

  '--vis-timeline-label-font-size': '12px',
  '--vis-timeline-label-color': '#6C778C',
  '--vis-timeline-label-user-select': 'none',
  '--vis-timeline-label-pointer-events': 'all',

  '--vis-timeline-arrow-color': '#6C778C',
  '--vis-timeline-arrow-stroke-width': '1.5',

  '--vis-timeline-cursor': 'default',
  '--vis-timeline-line-color': 'var(--vis-color-main)',
  '--vis-timeline-line-stroke-color': undefined,
  '--vis-timeline-line-stroke-width': '0',
  '--vis-timeline-line-hover-stroke-width': '0',
  '--vis-timeline-line-hover-stroke-color': '#6C778C',

  '--vis-timeline-row-icon-cursor': 'default',

  '--vis-dark-timeline-row-even-fill-color': '#292B34',
  '--vis-dark-timeline-row-odd-fill-color': '#333742',
  '--vis-dark-timeline-scrollbar-background-color': '#292B34',
  '--vis-dark-timeline-scrollbar-color': '#6C778C',
  '--vis-dark-timeline-label-color': '#EFF5F8',
  '--vis-dark-timeline-arrow-color': '#EFF5F8',
  '--vis-dark-timeline-line-hover-stroke-color': '#EFF5F8',
}

export const variables = getCssVarNames(cssVarDefaults)
injectGlobalCssVariables(cssVarDefaults, root)

export const background = css`
  label: background;
`

export const lines = css`
  label: lines;
`

export const lineGroup = css`
  label: line-group;
`

export const line = css`
  label: line;
  fill: var(--vis-timeline-line-color);
  cursor: var(--vis-timeline-cursor);

  stroke: var(--vis-timeline-line-stroke-color, var(--vis-timeline-row-even-fill-color));
  stroke-width: var(--vis-timeline-line-stroke-width);

  &.odd {
    stroke: var(--vis-timeline-line-stroke-color, var(--vis-timeline-row-odd-fill-color));
  }

  :hover {
    stroke-width: var(--vis-timeline-line-hover-stroke-width);
    stroke: var(--vis-timeline-line-hover-stroke-color);
  }
`

export const lineStartIcon = css`
  label: line-start-icon;
`

export const lineEndIcon = css`
  label: line-end-icon;
`

export const arrows = css`
  label: arrows;
`

export const arrow = css`
  label: arrow;
  fill: none;
  stroke: var(--vis-timeline-arrow-color);
  stroke-width: var(--vis-timeline-arrow-stroke-width);
`

export const rows = css`
  label: rows;
`

export const row = css`
  label: row;
  fill: var(--vis-timeline-row-even-fill-color);
  opacity: var(--vis-timeline-row-background-opacity);
`

export const rowOdd = css`
  label: row-odd;
  fill: var(--vis-timeline-row-odd-fill-color);
`

export const scrollbar = css`
  label: scroll-bar;
`

export const scrollbarHandle = css`
  label: scroll-bar-handle;
  fill: var(--vis-timeline-scrollbar-color);
`

export const scrollbarBackground = css`
  label: scroll-bar-background;
  fill: var(--vis-timeline-scrollbar-background-color);
`

export const labels = css`
  label: labels;
`

export const label = css`
  label: label;
  dominant-baseline: middle;
  font-size: var(--vis-timeline-label-font-size);
  fill: var(--vis-timeline-label-color);
  text-anchor: end;
  user-select: var(--vis-timeline-label-user-select);
  pointer-events: var(--vis-timeline-label-pointer-events);
`

export const labelBackground = css`
  label: label-background;
  fill: transparent;
  pointer-events: all;
`

export const rowIcons = css`
  label: row-icons;
`

export const rowIcon = css`
  label: row-icon;
  cursor: var(--vis-timeline-row-icon-cursor);
`
